import { Facebook, Instagram, Mail } from "lucide-react";

export const TEAM_EMAIL = "team@gateandgather.co.nz";

/**
 * Small footer meta row: social handles + copyright.
 *
 *   Instagram @gateandgather · Facebook @gateandgather · © 2026 Gate + Gather. All rights reserved.
 *
 * Kept in a single low-visual-weight row so socials feel like part of the
 * bottom line rather than a separate homepage section. Links open in a new
 * tab. Dropped into every public footer (Landing, FAQ, Pricing, ForGrowers,
 * Policies) so the marketing site and the socials read as one ecosystem.
 */
export default function FooterMeta() {
  return (
    <div
      className="flex flex-wrap items-center justify-center sm:justify-end gap-x-3 gap-y-1.5"
      data-testid="footer-meta"
    >
      <a
        href="https://www.instagram.com/gateandgather/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-instagram-link"
        className="inline-flex items-center gap-1.5 font-mono-label text-[10px] uppercase tracking-[0.14em] text-[#3F674E] hover:text-[#20251F] transition-colors"
      >
        <Instagram className="w-3.5 h-3.5" strokeWidth={2} aria-hidden="true" />
        <span>Instagram @gateandgather</span>
      </a>
      <span aria-hidden="true" className="text-stone-400 font-mono-label text-[10px]">·</span>
      <a
        href="https://www.facebook.com/gateandgather"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-facebook-link"
        className="inline-flex items-center gap-1.5 font-mono-label text-[10px] uppercase tracking-[0.14em] text-[#3F674E] hover:text-[#20251F] transition-colors"
      >
        <Facebook className="w-3.5 h-3.5" strokeWidth={2} aria-hidden="true" />
        <span>Facebook @gateandgather</span>
      </a>
      <span aria-hidden="true" className="text-stone-400 font-mono-label text-[10px]">·</span>
      <a
        href={`mailto:${TEAM_EMAIL}`}
        data-testid="footer-email-link"
        className="inline-flex items-center gap-1.5 font-mono-label text-[10px] uppercase tracking-[0.14em] text-[#3F674E] hover:text-[#20251F] transition-colors"
      >
        <Mail className="w-3.5 h-3.5" strokeWidth={2} aria-hidden="true" />
        <span className="normal-case tracking-normal">{TEAM_EMAIL}</span>
      </a>
      <span aria-hidden="true" className="text-stone-400 font-mono-label text-[10px]">·</span>
      <p
        className="font-mono-label text-[10px] uppercase tracking-[0.14em] text-[#6B6E67]"
        data-testid="footer-copyright"
      >
        © 2026 Gate + Gather. All rights reserved.
      </p>
    </div>
  );
}
